import { useResourceEditingSession } from 'hooks/useResourceEditingSession';
import { EditableResourceType, EditorDto } from 'store/api/editingSession';
import { FeatureFlag } from 'types/features';
import { useIsFeatureEnabled } from 'utils/useFeatureFlags';

/** The record whose editing session a section in edit holds, and the warning that names the other editors. */
export interface SectionEditingResource {
    resourceType: EditableResourceType;
    resourceId: string | number;
    messageId: string;
}

/**
 * The record's editing session for as long as the calling component is mounted: the section mounts it with its
 * editor, so entering edit starts the session and save, cancel or leaving the section end it. A case holds one
 * only with the case listener on, as its edit page does. Returns the other users editing the record.
 */
export const useSectionEditingSession = (resource: SectionEditingResource | undefined): EditorDto[] => {
    const isCaseListenerEnabled = useIsFeatureEnabled(FeatureFlag.CASE_LISTENER);
    const { otherEditors } = useResourceEditingSession({
        resourceType: resource?.resourceType ?? 'CASE',
        resourceId: resource?.resourceId,
        enabled: !!resource && (resource.resourceType !== 'CASE' || isCaseListenerEnabled),
    });
    return otherEditors;
};
